module.exports = __webpack_public_path__ + "static/media/400102_01.f62b607e.png";